/**
 * 客源渠道
 */
import React from 'react';
import intl from 'react-intl-universal';

import { renderContent } from '@/utils';
import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { useDetailData } from '@/pages/reservation/reverseRollback/helper';

const Index = () => {
  const { sourceChannelName, priceStrategyName, channelOrderNo } = useDetailData();

  return (
    <ContentBlock title={intl.get('reservation_channel_block_title')}>
      <FormItem label={intl.get('app_reservation_channel_name')}>{sourceChannelName}</FormItem>
      <FormItem label={intl.get('app_reservation_strategy_name')}>{priceStrategyName}</FormItem>
      <FormItem label={intl.get('app_reservation_channel_no')}>
        {renderContent(channelOrderNo)}
      </FormItem>
    </ContentBlock>
  );
};

export default Index;
